<template>
  <div>
    <wallet></wallet>
  </div>
</template>

<script>
import Wallet from '../components/Wallet.vue';

export default {
  data() {
    return {};
  },
  components: {
    Wallet,
  },
  methods: {},
};
</script>

<style></style>
